import './styles/style.css'
import {
  FullScreen,
  ScaleLine,
} from 'ol/control'
import {
  applyLayerVisibility,
  getVisibleLayers,
} from './map/state/layerState'
import {
  decodeLayers,
  encodeLayers,
} from './map/utils/urlState'
import { Attribution } from 'ol/control'
import { baseMaps } from './config/layers/basemaps'
import { createFeaturePopup } from './map/interactions/featurePopup'
import { createGeolocation } from './layers/gpsPosition'
import { createLayerSwitcher } from './map/controls/layerSwitcher'
import { createMap } from './map/createMap'
import { createMousePosition } from './map/controls/mousePosition'
import { createPermalink } from './map/state/permalink'
import { featureLayers } from './config/layers/featureLayers'
import { fromLonLat } from 'ol/proj'
import { overLayers } from './config/layers/overlayers'
import { specialDebugLayers } from './layers/debug'

// map defaults
let zoom = 12
let center = fromLonLat([ // Locatie Onze Lieve Vrouwetoren Amersfoort
  5.387201,
  52.155172,
])
let rotation = 0
let visibleLayers = ['Duitsland']

// set zoom, center and rotation based on URL
if (window.location.hash !== '') {
  // try to restore center, zoom-level and rotation from the URL
  const hash = window.location.hash.replace('#map=', '')
  const parts = hash.split('/')
  if (parts.length === 5) {
    zoom = parseInt(parts[0], 10)
    center = [
      parseFloat(parts[1]),
      parseFloat(parts[2]),
    ]
    rotation = parseFloat(parts[3])
    visibleLayers = decodeLayers(parts[4])
  }
}

// initiate map:
const map = createMap({
  target: 'map',
  viewOptions: {
    center,
    zoom,
    rotation,
  },
})

const view = map.getView()

map.addLayer(baseMaps)
map.addLayer(overLayers)
map.addLayer(featureLayers)
map.addLayer(specialDebugLayers)

console.log(visibleLayers)

applyLayerVisibility(map, visibleLayers)

const permalink = createPermalink(map, view, {
  encodeLayers: () => encodeLayers(getVisibleLayers(map)),
  decodeLayers: layers => applyLayerVisibility(map, layers),
})

map.on('moveend', permalink.update)
window.addEventListener('popstate', permalink.onPopState)

map.addControl(createLayerSwitcher())
map.addControl(createMousePosition())
map.addControl(new ScaleLine())
map.addControl(new FullScreen())
map.addControl(new Attribution({ collapsible: true }))

const gps = createGeolocation({
  projection: view.getProjection(),
})
gps.start()
map.addLayer(gps.layer)

///////////////////////////////////////////////////////////////////////////
/// //////////////////////       LoadSpinner       /////////////////////////
///////////////////////////////////////////////////////////////////////////

map.on('loadstart', function () {
  map.getTargetElement().classList.add('spinner')
})
map.on('loadend', function () {
  map.getTargetElement().classList.remove('spinner')
})

/*
██████   ██████  ██████        ██    ██ ██████  ███████
██   ██ ██    ██ ██   ██       ██    ██ ██   ██ ██
██████  ██    ██ ██████  █████ ██    ██ ██████  ███████
██      ██    ██ ██            ██    ██ ██           ██
██       ██████  ██             ██████  ██      ███████
*/

createFeaturePopup(map, {
  layers: [
    {
      title: 'Strandpalen',
      fields: [
        'kustvaknaa',
        'metrering',
      ],
    },
    {
      title: 'Vuurtorens',
      fields: [
        'NR',
        'NAAM',
      ],
    },
    {
      title: 'NAP peilpunten',
      fields: [
        'omschrijving',
        'hoogte',
      ],
    },
    {
      title: 'Earthquakes Significant Month',
      fields: [
        'mag',
        'place',
      ],
    },
    {
      title: 'Earthquakes all Month',
      fields: [
        'mag',
        'place',
      ],
    },
    {
      title: 'Gemeentegrenzen Nederland',
      fields: ['naam'],
    },
    {
      title: 'Provinciegrenzen Nederland',
      fields: ['naam'],
    },
    {
      title: 'Veiligheidsregio Nederland',
      fields: [
        'statcode',
        'statnaam',
      ],
    },
    {
      title: 'GGD Regio Nederland',
      fields: ['statnaam'],
    },
    {
      title: 'Wijken Nederland',
      fields: ['statnaam'],
    },
    {
      title: 'Buurten Nederland',
      fields: ['statnaam'],
    },
    {
      title: 'Kadaster Percelen',
      fields: ['perceelnummer'],
    },
    {
      title: 'Kadaster Bebouwing',
      fields: ['identificatieBAGPND'],
    },
    {
      title: 'Postcodes cijfer',
      fields: ['PC4'],
    },
    {
      title: 'Postcodes compleet',
      fields: ['PC6'],
    },
  ],
})
